import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function LegacyAuthRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={`/auth/action${location.search || ""}${location.hash || ""}`}
      replace
    />
  );
}
